import BUApi from './_buApi';
import httpClient from '@/apis/base/httpclient';

class BUCommitmentRequestAPI extends BUApi {
  constructor() {
    super();
  }
  controllerName = 'BUCommitmentRequests';
  /**
   * Lấy hợp đồng khung, hợp đồng thực hiện theo số cam kết chi
   * @param {*} payload
   * @returns
   * TTLONG
   */
  getContractNoAndContractFrameNoByRefNo(payload) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + `/contractNoByRefNo?commitmentRequestRefNo=${payload}`,
    };

    return httpClient.getAsync(request);
  }
}

export default new BUCommitmentRequestAPI();
